import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Button,
    FormField,
    Input,
    Label,
    Spacer,
    Text,
} from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

import PostingActions from 'app/shared/actions/PostingActions';
import { PropertiesSelectors } from 'app/shared/selectors';
import { RMWContext } from 'app/shared/providers/RMWContext';

const { property } = PostingActions;

const propTypes = {
    isSubmitDisabled: PropTypes.bool.isRequired,
    onStartSubmit: PropTypes.func.isRequired,
};

const DeleteButton = ({ isSubmitDisabled, onStartSubmit }) => {
    const dispatch = useDispatch();
    const { paths } = useContext(RMWContext);
    const [deletePropertyReason, setDeletePropertyReason] = useState('');
    const {
        listingAlias,
        street,
    } = useSelector(state => PropertiesSelectors.makeCurrentProperty(state));
    const handleDeletePropertySubmit = () => {
        // eslint-disable-next-line no-alert
        if (window.confirm(`Delete property? ${street} will no longer be one of your properties.`)) {
            onStartSubmit();
            dispatch(property.delete(listingAlias, deletePropertyReason))
                .then(() => window.router.updateLocation(paths.propertiesPage));
        }
    };

    const handleDeleteReasonBlur = e => setDeletePropertyReason(e.target.value);

    return (
        <div>
            <HR />
            <Text>Or, if you no longer manage this property:</Text>
            <FormField paddingY={1.5}>
                <Label>Reason for deletion</Label>
                <Input onBlur={handleDeleteReasonBlur} />
            </FormField>
            <Spacer paddingY="xs">
                <Button
                    fluid={true}
                    buttonType="secondary"
                    onClick={handleDeletePropertySubmit}
                    disabled={isSubmitDisabled || deletePropertyReason === ''}
                >
                    Delete property
                </Button>
            </Spacer>
        </div>
    );
};

DeleteButton.propTypes = propTypes;

export default DeleteButton;
